(function () {
  function init(root) {
    const form = root.querySelector('form.aceites-contact-form__form');
    const banner = root.querySelector('[data-aceites-contact-banner]');
    const submitBtn = root.querySelector('.aceites-contact-form__submit');
    const messages = root.querySelector('[data-aceites-contact-messages]');

    if (!form || !banner || !submitBtn) return;

    const successMsg = messages?.dataset.success || 'Gracias, hemos recibido tu mensaje.';
    const errorMsg = messages?.dataset.error || 'Ha ocurrido un error. Inténtalo de nuevo.';
    const validationMsg = messages?.dataset.errorValidation || 'Por favor revisa los campos del formulario.';

    function showBanner(type, content) {
      banner.className = 'aceites-contact-form__banner aceites-contact-form__banner--' + type;
      banner.innerHTML = content;
      banner.hidden = false;
      banner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function hideBanner() {
      banner.hidden = true;
      banner.innerHTML = '';
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function renderErrorList(items) {
      const lis = items.map((m) => '<li>' + escapeHtml(m) + '</li>').join('');
      return '<p>' + escapeHtml(validationMsg) + '</p><ul>' + lis + '</ul>';
    }

    function parseResponseHtml(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const success =
        doc.querySelector('.aceites-contact-form__banner--success') ||
        doc.querySelector('.aceites-contact-form__success') ||
        doc.querySelector('.form-status-list, .form__message--success');

      const errorList = doc.querySelector(
        '.aceites-contact-form__banner--error ul, .aceites-contact-form__errors ul'
      );
      const errorMessages = errorList
        ? Array.from(errorList.querySelectorAll('li')).map((li) => li.textContent.trim())
        : [];

      return { success: !!success, errors: errorMessages };
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      hideBanner();

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Enviando…';

      try {
        const formData = new FormData(form);
        const action = form.getAttribute('action') || window.location.pathname;

        const res = await fetch(action, {
          method: 'POST',
          body: formData,
          headers: { Accept: 'text/html' },
          credentials: 'same-origin',
        });

        const text = await res.text();
        const { success, errors } = parseResponseHtml(text);

        if (success) {
          showBanner('success', escapeHtml(successMsg));
          form.reset();
        } else if (errors.length) {
          showBanner('error', renderErrorList(errors));
        } else if (!res.ok) {
          showBanner('error', escapeHtml(errorMsg));
        } else {
          showBanner('success', escapeHtml(successMsg));
          form.reset();
        }
      } catch (err) {
        showBanner('error', escapeHtml(errorMsg));
      } finally {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
        submitBtn.textContent = originalText;
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-aceites-contact]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
